import api from '@pray/shared/utils/api';

export type GetRenewalRatesParams = {
  artistId: string;
  startDate?: string;
  endDate?: string;
  interval?: string;
};

export const getRenewalRates = async ({ artistId, startDate, endDate, interval }: GetRenewalRatesParams) => {
  const params: Record<string, string> = {};

  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  if (interval) params.interval = interval;

  const url = `/web/studio/artists/${artistId}/analytics/renewal`;
  const response = await api.executeGetRequest(url, params);

  return (response.data as any)?.data;
};
